import { gql } from "@apollo/client"

export const GET_ORGANIZATIONS_BY_ENTERPRISE = gql`
  query GetOrganizationsByEnterprise($staff_id: ID!, $enterprise_id: ID!) {
    organizationsByEnterpriseUid(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
    ) {
      organization_id
      organization_name
      organization_status
      organization_id_stamp
    }
  }
`

export const GET_ORGANIZATION = gql`
  query getOrganization($staff_id: ID!, $organization_id: ID!) {
    organization(staff_id: $staff_id, organization_id: $organization_id) {
      organization_logo
    }
  }
`

export const GET_KIOSK_TEMPLATES_ORGANIZATION = gql`
  query getKioskTemplates($organization_id: ID!) {
    getKioskTemplates(organization_id: $organization_id) {
      template_name
      template_title
      template_type
    }
  }
`

export const GET_TEMPLATE_FIELDS = gql`
  query getFields(
    $staff_id: String
    $organization_id: ID!
    $template_name: String
  ) {
    template: getTemplateMetadata(
      staff_id: $staff_id
      organization_id: $organization_id
      template_name: $template_name
    ) {
      blocks {
        idBlock
        block_name
        block_title
        system_required
        index
        fields {
          field_label
          field_name
          field_type
          field_visibility
          system_required
          field_conditional
          field_validation {
            required
          }
        }
      }
    }
  }
`

export const GET_KIOSK_STAFF_LIST = gql`
  query getStaffList($staff_id: ID!, $organization_id: ID!) {
    staffsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      staff_name_first
      staff_name_last
      staff_email_address
      staff_role_name
    }
  }
`

export const GET_PARTICIPANTS = gql`
  query AdvancedSearch($staff_id: ID!, $organization_id: ID!) {
    search: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      participant_id
      participant_membership_status
      participant_name_first
      participant_name_last
      participant_membership_id
    }
  }
`
